import React from 'react';

import { Pagination, Stack } from '@mui/material';

interface MuiPaginationProps {
  currentPage: number;
  pageCount: number;
  onPageChange: (page: number) => void;
}

const MuiPagination: React.FC<MuiPaginationProps> = ({
  currentPage,
  pageCount,
  onPageChange,
}) => {
  return (
    <Stack spacing={2} alignItems="center" sx={{ marginBlockStart: 4 }}>
      <Pagination
        count={pageCount}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        shape="rounded"
      />
    </Stack>
  );
};

export default MuiPagination;
